import { useEffect, useState } from 'react';
import { isJobRunning, Job } from '~/state/atoms/jobAtoms';
import { formatElapsed } from '~/utils/date';

export const useJobTimer = (job: Job): string => {
    const [elapsedTime, setElapsedTime] = useState<string>('');
    useEffect(() => {
        if (!isJobRunning(job.status) || !job.createdAt) {
            return;
        }

        const startTime = job.createdAt;
        const updateTimer = () => {
            setElapsedTime(formatElapsed((Date.now() - startTime) / 1000));
        };

        updateTimer();
        const intervalId = setInterval(updateTimer, 1000);

        return () => clearInterval(intervalId);
    }, [job.status, job.createdAt]);

    return elapsedTime;
};
